import React from 'react';
import { useTranslation } from 'react-i18next';

export const MaterialPropertiesInfo = () => {
  const { t } = useTranslation();

  return (
    <>
      {t('epdWizard.wizardStep2.info.materialProperties.declaration')}
      <br />
      <br />
      {t('epdWizard.wizardStep2.info.materialProperties.footer')}
    </>
  );
};
